const CHANNELS = [
    { icon: 'bi-envelope-fill', label: 'E-mail' },
    { icon: 'bi-chat-dots-fill', label: 'SMS' },
    { icon: 'bi-telephone-fill', label: 'Telephone' },
];

const FEATURES = [
    {
        icon: 'bi-bell-fill',
        title: 'Reminders',
        text: 'Reduce no-shows with timely, automated appointment reminders.',
    },
    {
        icon: 'bi-arrow-repeat',
        title: 'Recalls',
        text: 'Bring patients back on schedule with smart recall campaigns.',
    },
    {
        icon: 'bi-megaphone-fill',
        title: 'Notifications',
        text: 'Keep patients informed with instant, personalized updates.',
    },
    {
        icon: 'bi-mortarboard-fill',
        title: 'Education',
        text: 'Share relevant eye-care content that keeps patients engaged.',
    },
];

const BRAND = '#2563eb';
const LOGO = 'https://eyeconx.s3.us-east-2.amazonaws.com/3conx/assets/3f6f63b82cf94f13985e104afd45f226.png';

const Home = () => {
    return (
        <div style={{ backgroundColor: '#f6f9ff', minHeight: '100vh' }} className="min-vh-100">
            {/* Top bar */}
            <nav className="navbar bg-white border-bottom">
                <div className="container">
                    <span className="navbar-brand mb-0">
                        <img src={LOGO} alt="EyeconX" style={{ height: 40 }} />
                    </span>
                </div>
            </nav>

            {/* Hero */}
            <header className="py-5">
                <div className="container py-md-5">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6 text-center text-lg-start">
                            <span
                                className="badge rounded-pill mb-3 px-3 py-2"
                                style={{ backgroundColor: 'rgba(37,99,235,0.1)', color: BRAND }}
                            >
                                Patient communication, simplified
                            </span>
                            <h1 className="display-4 fw-bold mb-3 text-dark">
                                Connect with your patients{' '}
                                <span style={{ color: BRAND }}>effortlessly</span>
                            </h1>
                            <p className="lead text-muted mb-4">
                                EyeconX enables your practice to instantly send reminders,
                                recalls, notifications and education to patients via e-mail,
                                SMS and telephone.
                            </p>
                            <div className="d-flex flex-wrap gap-3 justify-content-center justify-content-lg-start">
                                {CHANNELS.map((c) => (
                                    <span
                                        key={c.label}
                                        className="d-inline-flex align-items-center gap-2 bg-white border rounded-pill px-3 py-2 shadow-sm text-dark"
                                    >
                                        <i className={`bi ${c.icon}`} style={{ color: BRAND }} />
                                        {c.label}
                                    </span>
                                ))}
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div
                                className="rounded-4 p-5 text-white text-center shadow"
                                style={{
                                    background: `linear-gradient(135deg, ${BRAND} 0%, #1e40af 100%)`,
                                }}
                            >
                                <span className="d-inline-flex align-items-center justify-content-center bg-white rounded-4 px-4 py-3 mb-4 shadow-sm">
                                    <img src={LOGO} alt="EyeconX" style={{ height: 56 }} />
                                </span>
                                <p className="mb-0 opacity-75">
                                    Smarter connections for modern eye-care practices.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* Features */}
            <section className="pb-5">
                <div className="container pb-md-5">
                    <div className="row g-4">
                        {FEATURES.map((f) => (
                            <div className="col-12 col-sm-6 col-lg-3" key={f.title}>
                                <div className="h-100 bg-white rounded-4 p-4 shadow-sm border text-center text-lg-start">
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center rounded-3 mb-3"
                                        style={{
                                            width: 52,
                                            height: 52,
                                            backgroundColor: 'rgba(37,99,235,0.1)',
                                            color: BRAND,
                                        }}
                                    >
                                        <i className={`bi ${f.icon} fs-4`} />
                                    </div>
                                    <h5 className="fw-semibold text-dark">{f.title}</h5>
                                    <p className="text-muted mb-0 small">{f.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="border-top bg-white py-4">
                <div className="container text-center text-muted small">
                    &copy; {new Date().getFullYear()} EyeconX. All rights reserved.
                </div>
            </footer>
        </div>
    );
};

export default Home;
